if (!Object.hasOwn) {
    Object.hasOwn = (obj: object, prop: PropertyKey): boolean => {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    };
}

export {};
